export const AUTOMOTIVE_META_DESCRIPTION =
  "Media monitoring and media analysis for automotive brands across Southeast Europe - launches, recalls, dealer networks and reputation analysis. Talk to us.";
